export type SpotLieClaim = { text: string; isLie: boolean; conceptId: string };
export type SpotLieRound = { intro: string; claims: SpotLieClaim[] };

const A = "adaptive_core";
const Y = "your_content";
const S = "self_hosted";
const P = "privacy_first";
const M = "measured_proof";

export const NOTANY_SPOTLIE_DECK: readonly SpotLieRound[] = [
  {
    intro: "A prospect summarizes what they heard about notanyai:",
    claims: [
      {
        text: "notanyai adapts question difficulty to each individual learner.",
        isLie: false,
        conceptId: A,
      },
      {
        text: "notanyai can teach any subject — AI literacy is just the first one.",
        isLie: false,
        conceptId: Y,
      },
      {
        text: "notanyai requires you to send your content to an external SaaS to work.",
        isLie: true,
        conceptId: S,
      },
    ],
  },
  {
    intro: "Notes from a security review:",
    claims: [
      { text: "It can run entirely inside your own cloud or VPC.", isLie: false, conceptId: S },
      {
        text: "Deleted accounts keep fully identifiable history forever.",
        isLie: true,
        conceptId: P,
      },
      {
        text: "Row-level security isolates each learner’s data.",
        isLie: false,
        conceptId: P,
      },
    ],
  },
  {
    intro: "About proving competence:",
    claims: [
      {
        text: "Mastery is tracked per concept and per person.",
        isLie: false,
        conceptId: M,
      },
      {
        text: "The only metric available is ‘number of videos watched’.",
        isLie: true,
        conceptId: M,
      },
      {
        text: "You can produce auditable evidence of who learned what.",
        isLie: false,
        conceptId: M,
      },
    ],
  },
  {
    intro: "How the engine chooses the next question:",
    claims: [
      {
        text: "It combines Elo, graph centrality, and a mastery model.",
        isLie: false,
        conceptId: A,
      },
      {
        text: "The selection logic is a black box you cannot inspect.",
        isLie: true,
        conceptId: A,
      },
      {
        text: "One correct answer can update related concepts on the graph.",
        isLie: false,
        conceptId: A,
      },
    ],
  },
  {
    intro: "On running costs and lock-in:",
    claims: [
      {
        text: "Production can run on a single small ARM VM.",
        isLie: false,
        conceptId: S,
      },
      {
        text: "There is a proprietary content format you can never export.",
        isLie: true,
        conceptId: Y,
      },
      {
        text: "The front end is a static bundle you can host anywhere.",
        isLie: false,
        conceptId: S,
      },
    ],
  },
  {
    intro: "The engagement loop, explained:",
    claims: [
      {
        text: "Streaks, mini-games, and quests keep learners returning.",
        isLie: false,
        conceptId: A,
      },
      {
        text: "Learners must sit through mandatory weekly meetings to progress.",
        isLie: true,
        conceptId: A,
      },
      {
        text: "Learners can pick a patient, drill, or balanced GameMaster style.",
        isLie: false,
        conceptId: A,
      },
    ],
  },
];
